import { SchedulerLesson } from "../../../models/schedule/lesson";
import {
  ISchedulerViewMode,
  SchedulerViewConfiguration,
} from "./ISchedulerViewMode";
import { IContent } from "../content-factory/IContent";
import { ContentFactory } from "../content-factory/ContentFactory";
import { PlusIcon } from "@heroicons/react/20/solid";
import { ComponentColor } from "../../../helpers/constants/types";
import classNames from "classnames";

export abstract class SchedulerViewModeBase
  implements ISchedulerViewMode<SchedulerLesson>
{
  abstract toggleActive(
    day: number,
    duration: number,
    componentSchedule: SchedulerLesson[][],
  ): SchedulerLesson[];
  abstract setDay(
    day: number,
    value: boolean,
    componentSchedule: SchedulerLesson[][],
  ): SchedulerLesson[];
  abstract displayLessons(
    startDate: Date,
    componentSchedule: SchedulerLesson[][],
    page?: number | undefined,
  ): SchedulerLesson[][];
  abstract getWeekday(
    startDate: Date,
    day: number,
  ): { id: number; name: string; shortName: string };
  abstract hasPage(
    page: number,
    componentSchedule: SchedulerLesson[][],
  ): boolean;

  constructor(public isReadOnly: boolean) {}

  getLessonComponentColor(lesson: SchedulerLesson): ComponentColor {
    if (lesson.teacherAccepted) {
      return "success";
    } else if (lesson.teacherApplications?.length) {
      return "accent";
    }
    return "primary";
  }

  getLessonComponentStyle(lesson: SchedulerLesson): string {
    return "";
  }

  getLessonContent(
    lesson: SchedulerLesson,
    viewConfiguration: SchedulerViewConfiguration,
  ): IContent | null {
    return ContentFactory.createContainer()
      .withChildren([
        ContentFactory.createIcon(<PlusIcon />).withCondition(
          () => !lesson.isActive && !!lesson.canActivate && !this.isReadOnly,
        ),
        ContentFactory.createText(
          viewConfiguration.size === "small"
            ? (lesson.name ?? "")[0]
            : lesson.name ?? "",
        ).withTestAttribute("content-text"),
        ContentFactory.createCircle(
          lesson.teacherAccepted
            ? `${lesson.teacherAccepted.initials}`
            : lesson.teacherApplications?.length
              ? `${lesson.teacherApplications.length}`
              : "",
        )
          .withTitle(
            lesson.teacherAccepted
              ? `${lesson.teacherAccepted?.name} ${lesson.teacherAccepted?.lastname}`
              : "Bewerbung vorhanden",
          )
          .withCondition(
            () =>
              !!lesson.teacherAccepted || !!lesson.teacherApplications?.length,
          )
          .withTestAttribute("content-badge"),
      ])
      .withStyle(
        classNames({
          "flex items-center w-full": true,
          "justify-between": lesson.isActive,
          "justify-center text-th-primary-900": !lesson.isActive && lesson.canActivate,
        }),
      )
      .withTestAttribute("content-container");
  }
}
